// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3H-2U","icon":"style_icon__3rnDn"};